import React from 'react';
import { Card, Col, Placeholder, Row } from 'react-bootstrap';

const STAT_ITEMS = 8;
const REPORT_ITEMS = 4;

export function DetailedPerInfluencerSkeleton() {
    return (
        <Card className="mb-3" aria-hidden="true">
            <Card.Body>
                <Row className="align-items-center">
                    <Col className="d-md-flex align-items-center justify-content-between">
                        <Placeholder as="div" animation="glow" className="d-flex align-items-center flex-grow-1">
                            <Placeholder className="skeleton skeleton-influencer-avatar" />
                            <div className="ml-2 flex-grow-1" style={{ maxWidth: 320 }}>
                                <Placeholder xs={8} className="skeleton skeleton-title d-block" />
                                <Placeholder xs={5} className="skeleton d-block mt-2" />
                            </div>
                        </Placeholder>
                        <Placeholder as="div" animation="glow" className="d-flex align-items-center mt-3 mt-md-0">
                            <Placeholder className="skeleton skeleton-outline-btn skeleton-outline-btn-lg mr-2" />
                            <Placeholder className="skeleton skeleton-outline-btn skeleton-outline-btn-lg" />
                        </Placeholder>
                    </Col>
                </Row>

                <Placeholder
                    as="div"
                    animation="glow"
                    className="my-3 d-flex flex-wrap justify-content-lg-around justify-content-evenly"
                    style={{ rowGap: 8 }}
                >
                    {Array.from({ length: STAT_ITEMS }).map((_, i) => (
                        <div key={i} className="px-2 d-flex flex-column align-items-center">
                            <Placeholder className="skeleton skeleton-stat-value" />
                            <Placeholder className="skeleton skeleton-stat-label mt-2" />
                        </div>
                    ))}
                </Placeholder>

                <Placeholder
                    as="div"
                    animation="glow"
                    className="d-flex flex-wrap justify-content-center justify-content-md-start"
                >
                    {Array.from({ length: REPORT_ITEMS }).map((_, i) => (
                        <div key={i} className="reporting-card-brand px-0">
                            <Placeholder className="skeleton skeleton-report-image" />
                            <div className="d-flex align-items-center my-2">
                                <Placeholder className="skeleton skeleton-platform-icon" />
                                <div className="ml-1 flex-grow-1">
                                    <Placeholder xs={9} className="skeleton d-block" />
                                    <Placeholder xs={6} className="skeleton d-block mt-1" />
                                </div>
                            </div>
                        </div>
                    ))}
                </Placeholder>
            </Card.Body>
        </Card>
    );
}
